import {fetch} from "utils/dataAccess";

export async function assign(order, data) {
    const response = await fetch(`/orders/${order.id}/assign`, {
        method: 'PUT',
        headers: new Headers({'Content-Type': 'application/ld+json'}),
        body: JSON.stringify(data)
    });

    return await response.json();
}
